<template>
  <b-sidebar
    v-model="toggle"
    width="60%"
    id="sidebar-right"
    title="Users"
    backdrop-variant="dark"
    backdrop
    no-header
    right
    shadow
    @hidden="$emit('hidden')"
  >
    <template #default="{}">
      <div
        class="d-flex text-light align-items-center px-3 py-2"
        style="background-color: #495057"
      >
        <strong class="mr-auto">Users</strong>
        <b-button size="sm" @click="$emit('hidden')">Close</b-button>
      </div>
      <div class="px-3 py-2">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Client Apps</h4>
                <hr />

                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-row form-group">
                          <label class="col-md-4 col-form-label">Keyword</label>
                          <div class="col-md-8">
                            <input
                              v-model="filterClientApp.keyword"
                              type="text"
                              placeholder="Name, Id"
                              class="form-control"
                            />
                            <!-- onkeypress="return event.charCode >= 48 && event.charCode <= 57" -->
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 text-sm-right">
                        <div class="button-items">
                          <button
                            type="button"
                            class="btn btn-primary btn-sm waves-effect"
                            @click="onFilterClientApp()"
                          >
                            <i
                              class="bx bx-search font-size-16 align-middle mr-2"
                            ></i>
                            Search
                          </button>
                          <button
                            type="button"
                            class="btn btn-light btn-sm waves-effect"
                            @click="onUserClear()"
                          >
                            <i
                              class="bx bx-reset font-size-16 align-middle mr-2"
                            ></i>
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2">
                      <div class="col-sm-8"></div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_length"
                          class="dataTables_length"
                        >
                          <label class="d-inline-flex align-items-center">
                            Size&nbsp;
                            <b-form-select
                              v-model="paginationClientApp.pageSize"
                              size="sm"
                              :options="pageOptions"
                              @change="onFilterClientApp()"
                            ></b-form-select
                            >&nbsp;Records
                          </label>
                        </div>
                      </div>
                      <div class="col-sm-12 col-md-6">
                        <div
                          id="tickets-table_filter"
                          class="dataTables_filter text-md-right"
                        >
                          <label class="d-inline-flex align-items-center">
                            <b-form-input
                              v-model="searchUser"
                              type="search"
                              placeholder="Search"
                              class="form-control form-control-sm ml-2"
                            ></b-form-input>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-if="
                        paginationClientApp.items &&
                        paginationClientApp.items.length > 0
                      "
                    >
                      <div class="col-lg-4">
                        <h6 class="mb-0">
                          <small class="text-muted">Result</small>
                          {{
                            (paginationClientApp.pageNo - 1) *
                              paginationClientApp.pageSize +
                            1
                          }}
                          -
                          {{
                            paginationClientApp.pageNo *
                              paginationClientApp.pageSize >
                            paginationClientApp.totalRecords
                              ? paginationClientApp.totalRecords
                              : paginationClientApp.pageNo *
                                paginationClientApp.pageSize
                          }}
                          <small class="text-muted">From</small>
                          {{ paginationClientApp.totalRecords }}
                          <small class="text-muted">Records</small>
                        </h6>
                      </div>
                      <div class="col-lg-8">
                        <b-pagination
                          :total-rows="paginationClientApp.totalRecords"
                          :per-page="paginationClientApp.pageSize"
                          v-model="paginationClientApp.pageNo"
                          @change="onFilterClientApp($event)"
                          class="pagination pagination-rounded justify-content-end mb-2"
                        />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="table-responsive">
                          <b-table
                            class="table table-centered table-nowrap"
                            ref="usertable"
                            :empty-text="'Not found any result'"
                            :show-empty="paginationClientApp.items.length == 0"
                            :bordered="true"
                            :filter="searchUser"
                            :items="paginationClientApp.items"
                            align="center"
                            v-bind:fields="userTablefields"
                            :perPage="paginationClientApp.pageSize"
                          >
                            <template v-slot:cell(id)="data">
                              <div class="text-right">
                                <b-form-radio
                                  v-model="userSelected"
                                  :value="data.value"
                                  class="custom-checkbox-info mb-3"
                                  checked
                                  :disabled="disabledGroupUsers(data.item.id)"
                                ></b-form-radio>
                              </div>
                            </template>
                            <template v-slot:cell(status)="data">
                              <b-badge
                                v-if="data.value === 'Active'"
                                variant="success"
                              >
                                {{ data.value }}
                              </b-badge>
                              <b-badge v-else variant="danger">
                                {{ data.value }}
                              </b-badge>
                            </template>
                          </b-table>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-12 text-sm-right">
                        <div class="button-items">
                          <button
                            v-show="userSelected && userSelected.length"
                            type="button"
                            class="btn btn-primary"
                            @click="onApplyAddUserClick()"
                          >
                            Apply
                          </button>

                          <!-- @click="onHide" -->
                          <button
                            ref="hideUser"
                            type="button"
                            class="btn btn-secondary"
                            @click="onHide"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import Vue from "vue";
import { eventBus } from "@/main.js";
import clientAppsService from "@/helpers/service/client-apps-service";

export default {
  components: {},
  props: {
    toggleSideBar: {
      type: Boolean,
      default: false,
    },
    applicationId: {
      type: String,
      default: "",
    },
    groupId: {
      type: String,
      default: "",
    },
    groupUsers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      toggle: false,
      searchUser: null,
      filterClientApp: {
        keyword: "",
      },
      paginationClientApp: {
        totalRecords: 0,
        pageNo: 0,
        pageSize: 10,
        totalPages: 0,
        hasPreviousPage: true,
        hasNextPage: true,
        items: [],
      },
      pageOptions: [5, 10, 25, 50, 100],
      userSelected: "",
      userTablefields: [
        {
          key: "id",
          label: "Select",
          thStyle: "width:80px",
          sortable: false,
        },
        {
          key: "display_name",
          label: "Name",
          sortable: true,
        },
        {
          key: "contact_email",
          label: "Contact Email",
          thStyle: "width:120px",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "status",
          label: "Status",
          thStyle: "width:120px",
          sortable: true,
          tdClass: "text-center",
        },
      ],
    };
  },
  computed: {},
  watch: {
    toggleSideBar: function (val) {
      this.toggle = val;
    },
  },
  methods: {
    async getGroupUsersSelected(groupId) {
      await this.$emit("getGroupUsersSelected", groupId);
    },
    async onFilterClientApp(pageNo) {
      if (pageNo) {
        this.paginationClientApp.pageNo = pageNo;
      } else {
        this.paginationClientApp.pageNo = 1;
      }
      let params = new URLSearchParams();
      params.append("pageSize", this.paginationClientApp.pageSize);
      if (this.paginationClientApp.pageNo > 0)
        params.append("page", this.paginationClientApp.pageNo);

      params.append("keyword", this.filterClientApp.keyword.trim() || "");

      this.userSelected = "";
      this.usersDefaultSelected = [];
      let result = await clientAppsService.getClientAppsAsync(params);
      if (result.status === 200) {
        this.paginationClientApp = result.data;
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async onApplyAddUserClick() {
      await this.$emit("clientAppsSelected", this.userSelected);
      this.$refs.hideUser.click();
    },
    onHide() {
      this.$emit("hidden");
    },
    onUserClear() {
      this.filterClientApp = {
        open_id: "",
        employee_id: "",
        name: "",
        email: "",
        groups: [],
        status: [],
      };
    },
    disabledGroupUsers(id) {
      return this.groupUsers.filter((q) => q.id === id).length > 0;
    },
  },
};
</script>
